(function($) {
    var documentLoad = function() {
        $('.sn1').each(function() {
            var secondaryNavModule = this;
            $(secondaryNavModule).find('.secondary-nav-item').matchHeight({ 'byRow': false });
        });
    };
    $(window).on('load', documentLoad);
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/shortcodes/secondary-nav.js